"use strict";

var _interopRequireWildcard = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;
var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.array.splice.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.some.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.set.js");
require("core-js/modules/es.set.difference.v2.js");
require("core-js/modules/es.set.intersection.v2.js");
require("core-js/modules/es.set.is-disjoint-from.v2.js");
require("core-js/modules/es.set.is-subset-of.v2.js");
require("core-js/modules/es.set.is-superset-of.v2.js");
require("core-js/modules/es.set.symmetric-difference.v2.js");
require("core-js/modules/es.set.union.v2.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _vue2Editor = require("vue2-editor");
var _elementUi = require("element-ui");
var _log = require("@/utils/log");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _cookie = require("@/utils/cookie");
var _utils = require("@/utils");
var Constants = _interopRequireWildcard(require("@lifehikes/lh-js-common-lib"));
var _index = _interopRequireDefault(require("../../../../components/EventTime/index.vue"));
var _subscriptions = require("@/api/subscriptions");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var tmpHikeGeninfo = {};
// const defaultValue = []
var _default2 = exports.default = {
  name: 'HikeGeninfo',
  components: {
    VueEditor: _vue2Editor.VueEditor,
    EventTime: _index.default
  },
  props: {
    parentHike: {
      type: Object,
      default: tmpHikeGeninfo
    },
    parentRelatedLoops: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    relatedLoopsLoading: {
      type: Boolean,
      default: false
    },
    displayType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      customToolbar: [['bold'], [{
        list: 'bullet'
      }]],
      loading: false,
      timeZoneList: _lifehikesInitData.ianaTimeZone,
      countryList: [],
      tagInputVisible: false,
      /* use for Tag component */
      tagInputValue: '',
      /* use for tag component */
      hike: {},
      HikeCategory: _lifehikesInitData.HikeCategory,
      loggedInUserTenants: [],
      subscriptionsList: [],
      subscriptionsLoading: false
    };
  },
  watch: {
    hike: {
      handler: function handler(newVal) {
        this.passBackGenInfo(newVal);
      },
      deep: true
    },
    parentRelatedLoops: {
      immediate: true,
      handler: function handler(loops) {
        var _this = this;
        this.subscriptionsList = [];
        var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
        if (!token || !Array.isArray(loops) || loops.length === 0) return;
        var subIds = new Set();
        loops.forEach(function (loop) {
          if (loop.metadata && loop.metadata.subscriptionId) {
            subIds.add(loop.metadata.subscriptionId);
          }
        });
        var uniqueSubIds = Array.from(subIds);
        if (uniqueSubIds.length === 0) return;
        this.subscriptionsLoading = true;
        var pending = uniqueSubIds.length;
        uniqueSubIds.forEach(function (subId) {
          (0, _subscriptions.getSubscriptionById)(token, subId).then(function (subResponse) {
            if (subResponse.data && subResponse.data.title) {
              if (!_this.subscriptionsList.some(function (s) {
                return s.id === subId;
              })) {
                _this.subscriptionsList.push({
                  id: subId,
                  title: subResponse.data.title
                });
              }
            }
          }).catch(function (error) {
            (0, _log.showDebugLog)('HikeGeninfo-getSubscriptionById-error', error);
            if (!_this.subscriptionsList.some(function (s) {
              return s.id === subId;
            })) {
              _this.subscriptionsList.push({
                id: subId,
                title: 'Subscription: ' + subId
              });
            }
          }).finally(function () {
            pending--;
            if (pending === 0) _this.subscriptionsLoading = false;
          });
        });
      }
    }
  },
  created: function created() {
    var _this2 = this;
    this.hike = this.parentHike;
    this.$store.dispatch('facets/getInitData', 'en').then(function () {
      _this2.countryList = _this2.$store.getters.countries;
    });
    var token = (0, _cookie.getCookie)('ACCESS_TOKEN');
    if (this.$store.getters.userMetadata && this.$store.getters.userMetadata.tenants) {
      this.loggedInUserTenants = this.$store.getters.userMetadata.tenants;
    }
  },
  methods: {
    getTenantLabel: _utils.getTenantLabel,
    openSubscription: function openSubscription(id) {
      window.open("/#/subscriptions/edit/".concat(id), '_blank');
    },
    openLoop: function openLoop(id) {
      window.open("/#/loop/edit/".concat(id), '_blank');
    },
    copyPostProgramFeedbackSurveyLandingPageLink: function copyPostProgramFeedbackSurveyLandingPageLink() {
      navigator.clipboard.writeText(this.hike.postProgramFeedbackSurveyLandingPageUrl);
      _elementUi.Message.info('Copied to Clipboard');
    },
    openPostProgramFeedbackSurveyLandingPage: function openPostProgramFeedbackSurveyLandingPage() {
      window.open(this.hike.postProgramFeedbackSurveyLandingPageUrl, '_blank');
    },
    prefillFeedbackLink: function prefillFeedbackLink() {
      this.hike.feedbackUrl = "https://otr.link/".concat(this.hike.internal.opportunityNumber);
    },
    passBackGenInfo: function passBackGenInfo(myHike) {
      this.$emit('updateParentGenInfo', myHike);
    },
    handleTagInputConfirm: function handleTagInputConfirm() {
      var inputValue = this.tagInputValue;
      if (inputValue && this.hike.tags.indexOf(inputValue) < 0) {
        this.hike.tags.push(inputValue);
      }
      this.tagInputVisible = false;
      this.tagInputValue = '';
    },
    showTagInput: function showTagInput() {
      var _this3 = this;
      this.tagInputVisible = true;
      this.$nextTick(function (_) {
        _this3.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleClose: function handleClose(tag) {
      this.hike.tags.splice(this.hike.tags.indexOf(tag), 1);
    },
    showUTCDate: function showUTCDate(utcDate) {
      // 'YYYY-MM-DD HH:mm:ss [GMT]Z[ (]z[)]'
      // 'YYYY-MM-DD HH:mm:ss (zZ)'
      return (0, _momentTimezone.default)(utcDate).utc().format('YYYY-MM-DD HH:mm:ss (z+0)');
    }
  }
};